module.exports = __webpack_public_path__ + "static/media/appHeaderLogo.69ab7c35.png";